module.exports = __webpack_public_path__ + "img/1125-joy-joy.aa2ee535.png";